@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: grid from "../../styles/layout.module.scss";
    grid-column: 1 / -1;
}

.grid {
    grid-column: content;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    // Every row matches the tallest, so all cards in the grid are one size.
    grid-auto-rows: 1fr;
    gap: var(--spacer-40);

    @media ($below-mobile) {
        grid-template-columns: 1fr;
        grid-auto-rows: auto;
        gap: var(--spacer-16);
    }
}

.card {
    composes: themed from "../../styles/themes.module.scss";
    display: flex;
    align-items: center;
    gap: var(--spacer-16);
    padding: var(--spacer-32) var(--spacer-24);
    border-radius: var(--border-radius-lg) var(--border-radius-lg)
        var(--border-radius-lg) 0;
    overflow: hidden;

    @media ($below-tablet) {
        flex-direction: column;
    }

    @media ($below-mobile) {
        flex-direction: row;
    }
}

.imageBlock {
    flex-shrink: 0;
    width: 30%;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;

    @media ($below-tablet) {
        width: 50%;
    }

    @media ($below-mobile) {
        width: 20%;
    }

    :global(.imageDataWrapper) {
        max-width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }
}

.textBlock {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-24);
}

.headline {
    composes: fontHB48 from "../../styles/typography.module.scss";
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
}

.cta {
    align-self: flex-start;
}
